// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './lib/css'
import './lib/script'
import './lib/global'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueStorage from 'vue-localstorage'
import EventBus from './lib/eventBus.js'
import axios from 'axios'
import VueApi from './plugins/api.js'
import VueFire from 'vuefire'
import VueMoment from './plugins/moment.js'
import LiquorTree from 'liquor-tree'
import VueDragResize from 'vue-drag-resize'
import MobileDetect from 'mobile-detect'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueAgile from 'vue-agile'
import VueScrollTo from 'vue-scrollto'
// import gcm from 'node-gcm'
import lightbox from 'vlightbox'
import Notifications from 'vue-notification'
import short from 'short-uuid'
// import resize from 'vue-resize-directive'
import VueFriendlyIframe from 'vue-friendly-iframe'
import JsonEditor from 'vue-json-edit'

import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

Vue.prototype.$bus = EventBus
Vue.prototype.$axios = axios

Vue.use(LiquorTree)
Vue.use(VueStorage)
Vue.use(VueApi)
Vue.use(VueFire)
Vue.use(VueMoment)
Vue.use(VueAgile)
Vue.use(VueScrollTo)
Vue.use(lightbox)
Vue.use(Notifications)
Vue.component('VueDragResize', VueDragResize)
Vue.use(VueFriendlyIframe)
Vue.use(JsonEditor)

import { db, dbStore, auth, fcm } from './firebase'
import { ResetDashboard } from './plugins/dashboard.js'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  data () {
    return {
      title: 'Printer Counters Monitoring',
      version: '3.1.9',
      installerRootAddress: '',
      isFirstLogin: false,
      detect: new MobileDetect(window.navigator.userAgent),
      device: { isMobile: false, os: '' },
      hasNewVersion: false,
      token: '',
      user: null,
      activeMenu: 'Dashboard',
      hasUser: false,
      hideSideMenu: false,
      slideTopItems: [],
      slideItems: [],
      txtSearch: '',
      sites: [],
      dealers: [],
      customers: [],
      isLoading: false,
      // customerSites: [],
      filter: {
        dealerKey: 'All',
        customerKey: 'All',
        siteKey: 'All',
        printerKey: 'All'
      },
      userHistory: {
        selectedPage: 'Dashboard',
        selectedDealer: '',
        selectedCustomer: 'All',
        selectedSite: 'All',
        selectedTab: '',
        fromDate: '',
        toDate: ''
      },
      timer: null,
      refreshPrintersList: [],
      alertTypes: [
        { title: 'System', value: 'System', iconClass: 'fa fa-bell-o iconInformation' },
        { title: 'Information', value: 'Information', iconClass: 'fa fa-exclamation-circle iconInformation rotate180' },
        { title: 'Warning', value: 'Warning', iconClass: 'fa fa-exclamation-triangle iconWarning' },
        { title: 'Critical', value: 'Critical', iconClass: 'fa fa-times-circle iconError' },
        { title: 'Export Printers Daily', value: 'ExportPrinters', iconClass: 'fa fa-download iconSuccess' }
      ],
      // routeExceptions: ['Register', 'Login', 'Contact', 'Download', 'Thanks', 'Greeting', 'Guide', 'Verify'],
      routeExceptions: ['Register', 'Login', 'Contact', 'Download', 'Thanks', 'Greeting', 'Verify'],
      dashData: {
        TotalDealers: 0,
        TotalCustomers: 0,
        TotalSites: 0,
        TotalPrinters: 0,
        TotalUsers: 0,
        PrintersStatus: {
          TotalOnline: 0,
          TotalOffline: 0,
          TotalOutPaper: 0,
          TotalOutToner: 0,
          TotalError: 0
        },
        barChartData: null,
        recentAlerts: []
      },
      Announcement: {
        IsVisible: false,
        Title: '',
        Info: ''
      },
      hasAnnouncement: false,
      showStatuses: false,
      printersByStatus: {
        Online: [],
        Offline: [],
        OutPaper: [],
        OutToner: [],
        Error: []
      },
      installerLinks: {
        LanInstaller: '',
        UsbInstaller: ''
      }
    }
  },
  firebase: function () {
    var vm = this
    vm.checkUser()
    return {
      webVersion: {
        source: db.ref('Dashboard/Admin/Version'),
        asObject: true,
        cancelCallback: function () { },
        readyCallback: function () {
          if (this.webVersion && this.webVersion['.value']) {
            console.log('webVersion = ' + this.webVersion['.value'])
            // this.checkVersion = this.webVersion['.value']
          } else {
            console.log('webVersion = UNKNOWN')
          }
        }
      },
      installerRootAddress: {
        source: db.ref('ApiFunctions/InstallerRootAddress'),
        asObject: true,
        cancelCallback: function () { },
        readyCallback: function () {
          if (this.installerRootAddress && this.installerRootAddress['.value']) {
            console.log('installerRootAddress = ' + this.installerRootAddress['.value'])
            this.installerRootAddress = this.installerRootAddress['.value']
            console.log('installerRootAddress = ' + this.installerRootAddress)
          } else {
            console.log('installerRootAddress = UNKNOWN')
          }
        }
      }
      // users: usersRef.orderByKey(),
      // lockedUser: usersRef.orderByChild('uid').equalTo(auth.currentUser.uid)
    }
  },
  created () {
    // this.checkUser()
    this.checkDevice()
    this.initFCM()
    ResetDashboard(this)
    this.PushTonerHistory()
  },
  mounted () {
    this.checkVersion()
    this.checkAnnouncement()
  },
  computed: {
    isLoggedIn () {
      if (this.user && this.user['.key']) {
        return true
      } else {
        return false
      }
    },
    isAdmin () {
      if (this.user) {
        return this.user.UserType === 'Admin'
      } else {
        return false
      }
    },
    isDealerOLD () {
      if (this.user) {
        return this.user.UserType === 'Dealer'
      } else {
        return false
      }
    },
    isDealer () {
      if (this.user) {
        return this.user.UserType === 'Dealer' // || this.user.UserType === 'DealerAssistance'
      } else {
        return false
      }
    },
    isDealerAssistance () {
      if (this.user) {
        return this.user.UserType === 'DealerAssistance'
      } else {
        return false
      }
    },
    isCustomer () {
      if (this.user) {
        return this.user.UserType === 'Customer'
      } else {
        return false
      }
    },
    userFullName () {
      if (this.user) {
        return this.user.FirstName + ' ' + this.user.LastName
      } else {
        return ''
      }
    }
  },
  watch: {
    hasAnnouncement (val) {
      if (val) {
        this.showAnnouncement()
        $root.showNewBox
      }
    },
    adminOn (val) {
    },
    customers (val) {
      // console.log(val)
    }
  },
  methods: {
    PushTonerHistory () {
      console.log('Push Toner History [printer] (If Changed!)')
      let currentPrinter = {
        Logged: '2023-02-26 17:14:16',
        PageCount: '20100',
        BlackTonerLeft: '99.00%',
        CyanTonerLeft: '',
        MagentaTonerLeft: '',
        YellowTonerLeft: '',
        SiteKey: '',
        // Extras: 'TonerChange: Cyan'
        Extras: 'TonerChange: Black'
      }
      let tonerCollectionPath = ''
      tonerCollectionPath += '/TonerHistory/'
      tonerCollectionPath += 'Dealers/'
      tonerCollectionPath += 'GfRz9vbMH6WycVs7LkOslj4yHch1' + '/'
      tonerCollectionPath += 'Customers/'
      tonerCollectionPath += '-NO8wb6e4uTk-OvHNNDa' + '/'
      tonerCollectionPath += 'Printers/'
      tonerCollectionPath += '00-17-C8-B0-9E-91' + '/'
      console.log('PushTonerHistory to path: ' + tonerCollectionPath)
      dbStore.collection(tonerCollectionPath).doc('Toners').get().then((tonerDoc) => {
        let toners = {}
        console.log('tonerDoc.exists: ' + tonerDoc.exists)
        if (tonerDoc.exists) {
          toners = tonerDoc.data()
          if (currentPrinter && currentPrinter.Extras && currentPrinter.Extras.length > 0) {
            console.log('currentPrinter.Extras: ' + currentPrinter.Extras)
            let extrasLower = currentPrinter.Extras.toLowerCase()
            console.log('extrasLower: ' + extrasLower)
            let extrasIndex = extrasLower.toLowerCase().indexOf(('TonerChange').toLowerCase())
            console.log('extrasIndex: ' + extrasIndex)
            if (currentPrinter.Extras.toLowerCase().indexOf(('TonerChange').toLowerCase()) >= 0) {
              console.log('currentPrinter.Extras: has >> TonerChange')
              if (currentPrinter.Extras.toLowerCase().indexOf(('Black').toLowerCase()) >= 0) {
                console.log('currentPrinter.Extras: Black')
                let lenB = toners.Black.length
                toners.Black[lenB - 1].EndLogged = currentPrinter.Logged
                toners.Black[lenB - 1].EndToner = currentPrinter.BlackTonerLeft
                toners.Black[lenB - 1].EndCounter = Number(currentPrinter.PageCount)
                toners.Black.push({
                  StartLogged: currentPrinter.Logged,
                  StartToner: currentPrinter.BlackTonerLeft,
                  StartCounter: Number(currentPrinter.PageCount),
                  EndLogged: currentPrinter.Logged,
                  EndToner: currentPrinter.BlackTonerLeft,
                  EndCounter: Number(currentPrinter.PageCount),
                  SiteKey: currentPrinter.SiteKey
                })
              }
              if (currentPrinter.Extras.toLowerCase().indexOf(('Cyan').toLowerCase()) >= 0) {
                console.log('currentPrinter.Extras: Cyan')
                let lenB = toners.Black.length
                toners.Cyan[lenB - 1].EndLogged = currentPrinter.Logged
                toners.Cyan[lenB - 1].EndToner = currentPrinter.CyanTonerLeft
                toners.Cyan[lenB - 1].EndCounter = Number(currentPrinter.PageCount)
                toners.Cyan.push({
                  StartLogged: currentPrinter.Logged,
                  StartToner: currentPrinter.CyanTonerLeft,
                  StartCounter: Number(currentPrinter.PageCount),
                  EndLogged: currentPrinter.Logged,
                  EndToner: currentPrinter.CyanTonerLeft,
                  EndCounter: Number(currentPrinter.PageCount),
                  SiteKey: currentPrinter.SiteKey
                })
              }
              if (currentPrinter.Extras.toLowerCase().indexOf(('Magenta').toLowerCase()) >= 0) {
                console.log('currentPrinter.Extras: Magenta')
                let lenB = toners.Black.length
                toners.Magenta[lenB - 1].EndLogged = currentPrinter.Logged
                toners.Magenta[lenB - 1].EndToner = currentPrinter.MagentaTonerLeft
                toners.Magenta[lenB - 1].EndCounter = Number(currentPrinter.PageCount)
                toners.Magenta.push({
                  StartLogged: currentPrinter.Logged,
                  StartToner: currentPrinter.MagentaTonerLeft,
                  StartCounter: Number(currentPrinter.PageCount),
                  EndLogged: currentPrinter.Logged,
                  EndToner: currentPrinter.MagentaTonerLeft,
                  EndCounter: Number(currentPrinter.PageCount),
                  SiteKey: currentPrinter.SiteKey
                })
              }
              if (currentPrinter.Extras.toLowerCase().indexOf(('Yellow').toLowerCase()) >= 0) {
                console.log('currentPrinter.Extras: Yellow')
                let lenB = toners.Black.length
                toners.Yellow[lenB - 1].EndLogged = currentPrinter.Logged
                toners.Yellow[lenB - 1].EndToner = currentPrinter.YellowTonerLeft
                toners.Yellow[lenB - 1].EndCounter = Number(currentPrinter.PageCount)
                toners.Yellow.push({
                  StartLogged: currentPrinter.Logged,
                  StartToner: currentPrinter.YellowTonerLeft,
                  StartCounter: Number(currentPrinter.PageCount),
                  EndLogged: currentPrinter.Logged,
                  EndToner: currentPrinter.YellowTonerLeft,
                  EndCounter: Number(currentPrinter.PageCount),
                  SiteKey: currentPrinter.SiteKey
                })
              }
            }
          }
          console.log('toners: extras')
          console.log(toners)
        } else {
          toners = {
            Black: [],
            Cyan: [],
            Magenta: [],
            Yellow: []
          }
          toners.Black.push({
            StartLogged: currentPrinter.Logged,
            StartToner: currentPrinter.BlackTonerLeft,
            StartCounter: Number(currentPrinter.PageCount),
            EndLogged: currentPrinter.Logged,
            EndToner: currentPrinter.BlackTonerLeft,
            EndCounter: Number(currentPrinter.PageCount),
            SiteKey: currentPrinter.SiteKey
          })
          toners.Cyan.push({
            StartLogged: currentPrinter.Logged,
            StartToner: currentPrinter.CyanTonerLeft,
            StartCounter: Number(currentPrinter.PageCount),
            EndLogged: currentPrinter.Logged,
            EndToner: currentPrinter.CyanTonerLeft,
            EndCounter: Number(currentPrinter.PageCount),
            SiteKey: currentPrinter.SiteKey
          })
          toners.Magenta.push({
            StartLogged: currentPrinter.Logged,
            StartToner: currentPrinter.MagentaTonerLeft,
            StartCounter: Number(currentPrinter.PageCount),
            EndLogged: currentPrinter.Logged,
            EndToner: currentPrinter.MagentaTonerLeft,
            EndCounter: Number(currentPrinter.PageCount),
            SiteKey: currentPrinter.SiteKey
          })
          toners.Yellow.push({
            StartLogged: currentPrinter.Logged,
            StartToner: currentPrinter.YellowTonerLeft,
            StartCounter: Number(currentPrinter.PageCount),
            EndLogged: currentPrinter.Logged,
            EndToner: currentPrinter.YellowTonerLeft,
            EndCounter: Number(currentPrinter.PageCount),
            SiteKey: currentPrinter.SiteKey
          })
          console.log('toners: ')
          console.log(toners)
        }
      }).catch((error) => {
        console.log('Error getting Toners:', error)
      })
    },
    checkAnnouncement () {
      let vm = this
      vm.Announcement = { IsVisible: false, Title: '', Info: '' }
      db.ref('Announcement').on('value', (snapAnnouncement) => {
        let dataAnnouncement = snapAnnouncement.val()
        console.log('Announcement = ' + JSON.stringify(dataAnnouncement))
        if (dataAnnouncement) {
          vm.Announcement = dataAnnouncement
          if (vm.Announcement.IsVisible) {
            if (vm.Announcement.IsForLockedUsers) {
              if (vm.user) {
                if (vm.user.Locked) {
                  vm.hasAnnouncement = true
                } else {
                  vm.hasAnnouncement = false
                }
              } else {
                vm.hasAnnouncement = false
              }
            } else {
              vm.hasAnnouncement = true
            }
          } else {
            vm.hasAnnouncement = false
          }
        }
      })
    },
    showAnnouncement () {
      console.log('showAnnouncement() ... ')
      const vm = this
      vm.hasUser = false
      vm.user = null
      vm.$router.push({ name: 'Announcement' })
      auth.signOut().then(function () {
        vm.$localStorage.remove('user')
      }).catch(function (error) {
        console.log(error)
      })
    },
    checkDevice () {
      let vm = this
      /*
      console.log('this.detect.mobile() >> ' + vm.detect.mobile())
      console.log('this.detect.phone() >> ' + vm.detect.phone())
      console.log('this.detect.tablet() >> ' + vm.detect.tablet())
      console.log('this.detect.userAgent() >> ' + vm.detect.userAgent())
      console.log('this.detect.os() >> ' + vm.detect.os())
      console.log('this.detect.is(iPhone) >> ' + vm.detect.is('iPhone'))
      console.log('this.detect.is(AndroidOS) >> ' + vm.detect.is('AndroidOS'))
      console.log('this.detect.version(Webkit) >> ' + vm.detect.version('Webkit'))
      */
      vm.device.isMobile = false
      vm.device.isTablet = false
      if (vm.detect.phone()) {
        vm.device.isMobile = true
        vm.device.os = this.detect.os()
        console.log('>>> Run on mobile <<<')
      } else if (vm.detect.tablet()) {
        vm.device.isTablet = true
        console.log('>>> Run on tablet <<<')
      } else {
        console.log('>>> Run on browser <<<')
      }
    },
    resetRefreshPrinters () {
      let vm = this
      console.log('resetRefreshPrinters()...')
      let clearIndexs = []
      if (vm.refreshPrintersList.length > 0) {
        for (let i = 0; i < vm.refreshPrintersList.length; i++) {
          if (vm.refreshPrintersList[i].MAC && vm.refreshPrintersList[i].Time) {
            var now = vm.$moment()
            var refreshTime = vm.$moment(vm.refreshPrintersList[i].Time, 'YYYY-MM-DD HH:mm:ss')
            let diffTime = now.diff(refreshTime, 'seconds')
            if (diffTime >= 60) {
              db.ref('Printers/' + vm.refreshPrintersList[i].MAC + '/IsRefresh').set('Ready')
              vm.refreshPrintersList[i].MAC = null
              vm.refreshPrintersList[i].Time = null
              clearIndexs.push(i)
            }
          }
        }
        for (let i = 0; i < clearIndexs.length; i++) {
          vm.refreshPrintersList.splice(i, 1)
        }
      } else {
        clearInterval(vm.timer)
        vm.timer = null
      }
    },
    checkVersion () {
      let vm = this
      db.ref('Dashboard/Admin/Version').on('value', (snapVersion) => {
        let checkVersion = snapVersion.val()
        console.log('checkVersion = ' + checkVersion)
        if (checkVersion) {
          // if (Number(checkVersion) > Number(vm.version)) {
          if (checkVersion !== vm.version) {
            vm.hasNewVersion = true
            console.log('New Version, Please refresh your browser! ')
            vm.confirmRefresh(checkVersion)
          } else {
            vm.hasNewVersion = false
          }
        }
      })
    },
    confirmRefresh (newVer) {
      let vm = this
      vm.$bus.$emit('modal-open', {
        title: 'New Version ' + newVer,
        description: 'Please refresh your browser to load newer web version!',
        type: 'modal-primary',
        confirmText: 'Refresh',
        cancelText: 'Cancel',
        confirmBefore: () => {
        },
        confirmAfter: () => {
          location.reload(true)
        },
        cancelBefore: () => {
        },
        cancelAfter: () => {
        }
      })
    },
    initFCM () {
      let vm = this
      if ('serviceWorker' in navigator) {
        console.log('Start registring service worker ...')
        navigator.serviceWorker.register('static/fcm-sw.js')
          .then(function (registration) {
            console.log('Service worker was registered.')
            return fcm.useServiceWorker(registration)
          }).then(function () {
            fcm.requestPermission().then(function () {
              console.log('Notification permission granted.')
              return fcm.getToken()
            }).then(function (token) {
              console.log('Notification token is ready.')
              console.log(token)
              vm.token = token
            }).catch(function (err) {
              console.log('Unable to get permission to notify.', err)
            })
          }).catch(function (err) {
            console.log('Service worker failed :', err)
          })
      } else {
        console.log('Service worker not available!!')
      }

      if (fcm) {
        fcm.onMessage(function (payload) {
          console.log('Message received. ', payload)

          var notificationOptions = {
            body: payload.notification.body,
            icon: payload.notification.icon
          }
          new Notification(payload.notification.title, notificationOptions)
        })
      }
    },
    resetFilter () {
      this.filter = {
        dealerKey: 'All',
        customerKey: 'All',
        siteKey: 'All',
        printerKey: 'All'
      }

      // if (this.user && !this.isAdmin) {
      //  if (this.user.UserType === 'Dealer') {
      //    this.filter.dealerKey = this.user['.key']
      //  } else {
      //    this.filter.dealerKey = this.user.DealerUID
      //  }
      // }

      if (this.user && !this.isAdmin) {
        if (!this.isAdmin) {
          if (vm.user.UserType === 'Dealer') {
            this.filter.dealerKey = vm.user['.key']
          } else if (vm.user.UserType === 'DealerAssistance') {
            this.filter.dealerKey = vm.user.DealerUID
          } else if (vm.user.UserType === 'Customer') {
            this.filter.dealerKey = vm.user.DealerUID
            this.filter.customerKey = vm.user.CustomerKey
            this.userHistory.selectedCustomer = vm.user.CustomerKey
          } else {
            this.filter.dealerKey = vm.user.DealerUID
          }
        }
      }
    },
    UpdateAllUsers () {
      /*
      let vm = this
      let usersPath = 'Users'
      let usersRef = db.ref(usersPath)
      let allUsers = usersRef.orderByKey().then(function (snapUsers) {
      })
      */
    },
    checkUser () {
      const vm = this
      if (vm.HasAnnouncement) {
        vm.showAnnouncement()
        vm.$router.push({ name: 'Announcement' })
      }
      console.log('checkUser()')
      vm.UpdateAllUsers()
      vm.getUserHistory()
      const jsUser = vm.$localStorage.get('user')
      vm.user = JSON.parse(jsUser)
      if (vm.user && vm.user.Token) {
        if (vm.token) {
          if (vm.user.Token !== vm.token) {
            vm.user.Token = vm.token
            db.ref('Users/' + vm.user['.key'] + '/Token').set(vm.user.Token)
          }
        }
      }
      // console.log(vm.user)
      console.log('vm.$route.name = ' + vm.$route.name)
      console.log('vm.userHistory.selectedPage = ' + vm.userHistory.selectedPage)
      if (vm.user && vm.user['.key']) {
        console.log('USER >>> ' + vm.userFullName)
        if (!vm.user.LastLogin) {
          vm.isFirstLogin = true
        } else {
          vm.isFirstLogin = false
        }
        vm.hasUser = true
        if (!vm.isAdmin) {
          if (vm.user.UserType === 'Dealer') {
            vm.user.DealerUID = vm.user['.key']
            vm.filter.dealerKey = vm.user['.key']
          } if (vm.user.UserType === 'Customer') {
            vm.filter.dealerKey = vm.user.DealerUID
            vm.filter.customerKey = vm.user.CustomerKey
            vm.userHistory.selectedCustomer = vm.user.CustomerKey
          } else {
            vm.filter.dealerKey = vm.user.DealerUID
          }
          // vm.filter.dealerKey
          db.ref('Users').orderByChild('DealerUID').equalTo(vm.filter.dealerKey).once('value', (snapData) => {
            const data = snapData.val()
            if (data) {
              const mKeys = Object.keys(data)
              let found = mKeys.length
              console.log('Users found = ' + found)
              for (let i = 0; i < found; i++) {
                let mKey = mKeys[i]
                let mUser = data[mKey]
                if (mUser && mUser.UserType === 'SiteAuth') {
                  vm.user.AuthKey = mKey
                  break
                }
              }
              db.ref('Dealers/' + vm.filter.dealerKey + '/InstallerLinks').orderByKey().once('value', (snapData) => {
                const data = snapData.val()
                if (data) {
                  console.log(data)
                  vm.installerLinks = {
                    LanInstaller: data.Lan,
                    UsbInstaller: data.Usb
                  }
                } else {
                  console.log('checkUser() Dealer >>> InstallerLinks is Empty')
                  console.log(data)
                  let UID = vm.user.AuthKey
                  let installerLinks = {
                    Lan: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Network/NetworkPrinterCounters@' + UID + '@.msi',
                    Usb: 'https://www.printercountersdownloads.com/PrinterCountersWS/Downloads/' + UID + '/Local/LocalPrinterCounters@' + UID + '@.msi'
                  }
                  db.ref('Dealers/' + vm.filter.dealerKey + '/InstallerLinks').set(installerLinks)
                  vm.installerLinks = {
                    LanInstaller: installerLinks.Lan,
                    UsbInstaller: installerLinks.Usb
                  }
                }
              })
            }
          })
        } else {
          vm.filter.dealerKey = 'All'
        }
        // CalculateDashboard(vm, db)
        // vm.loadDashboard()
      }
      vm.checkRoute()
      // vm.userHistory
    },
    checkRoute () {
      const vm = this
      if (vm.user && vm.user['.key']) {
        if (vm.userHistory.selectedPage && (vm.userHistory.selectedPage !== 'Login')) {
          if (!(vm.$route.name === 'PrinterHistory') && !(vm.$route.name === 'Printer') && !(vm.$route.name === 'Dealer') && !(vm.$route.name === 'Home')) {
            vm.goto(vm.userHistory.selectedPage)
          }
        } else {
          vm.userHistory.selectedPage = 'Dashboard'
          vm.goto('Dashboard')
        }
      } else {
        // vm.userHistory.selectedPage = 'Dashboard'
        // if (vm.$route.name === 'Register' || vm.$route.name === 'Login' || vm.$route.name === 'Contact') {
        // if (vm.$route.name === 'Register' || vm.$route.name === 'Login') {
        if (vm.$root.routeExceptions.includes(vm.$route.name)) {
          // vm.goto(vm.$route.name)
        } else {
          vm.goto('Home')
        }
      }
    },
    calcPercent (a, b) {
      // console.log(a)
      // console.log(b)
      let percent = '0%'
      if (isNaN(a) || isNaN(b)) {
        // console.log(isNaN(a))
        // console.log(isNaN(b))
        percent = '0%'
      } else {
        percent = Math.round((a / b) * 100)
      }
      // console.log(percent)
      return percent + '%'
    },
    goto (page) {
      console.log('goto bbb (' + page + ')')
      // this.activeMenu = page
      this.hideSideMenu = false
      this.filter = {
        dealerKey: this.filter.dealerKey ? this.filter.dealerKey : 'All',
        customerKey: this.filter.customerKey ? this.filter.customerKey : 'All',
        siteKey: 'All', // this.filter.siteKey ? this.filter.siteKey : 'All',
        printerKey: this.filter.printerKey ? this.filter.printerKey : 'All'
      }
      let route = { name: page }

      if (this.userHistory.selectedCustomer) {
        this.filter.customerKey = this.userHistory.selectedCustomer
      }
      if (this.userHistory.selectedSite) {
        this.filter.siteKey = this.userHistory.selectedSite
      }
      switch (page) {
        case 'Printers': route = { name: page, params: { customerKey: this.filter.customerKey, siteKey: this.filter.siteKey } }; break
        case 'TonerHistory': route = { name: page, params: { customerKey: this.filter.customerKey, siteKey: this.filter.siteKey } }; break
        case 'AllPrinters': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'NA' } }; break
        case 'PrintersOnline': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'Online' } }; break
        case 'PrintersOffline': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'Offline' } }; break
        case 'PrintersOutOfPaper': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'OutOfPaper' } }; break
        case 'PrintersLowToner': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'LowToner' } }; break
        case 'PrintersErrors': route = { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'Errors' } }; break
        // case 'Printers': route = { name: page, params: { customerKey: this.userHistory.selectedCustomer, siteKey: this.userHistory.selectedSite } }; break
        case 'History': route = { name: page, params: { customerKey: this.userHistory.selectedCustomer, siteKey: this.userHistory.selectedSite } }; break
        case 'Sites': route = { name: page, params: { customerKey: this.filter.customerKey } }; break
        case 'ReportDesigner': route = { name: page, params: { reportKey: 'NA' } }; break
        case 'Updates': this.hideSideMenu = true; break
        default: route = { name: page }; break
      }

      // if (this.hideSideMenu) {
      //   $('.sidebar-toggle').click()
      // }
      this.txtSearch = ''
      this.userHistory.selectedPage = page
      this.setUserHistory()
      console.log('route: ')
      console.log(route)
      this.$router.push(route)
      // this.$router.go(route)
    },
    login (username, password) {
      const vm = this
      auth.signInWithEmailAndPassword(username, password).then(function () {
        console.log(auth.currentUser)
        vm.user = {
          uid: auth.currentUser.uid,
          email: auth.currentUser.email,
          displayName: auth.currentUser.displayName,
          photoURL: auth.currentUser.photoURL
        }
        vm.$localStorage.set('user', JSON.stringify(vm.user))
      }, function (error) {
        var errorCode = error.code
        var errorMessage = error.message

        console.log('errorCode: ' + errorCode)
        console.log('errorMessage: ' + errorMessage)

        // vm.error = '* ';
        // vm.isWorking = false;
      })
    },
    logout () {
      console.log('logout() ... ')
      const vm = this
      vm.hasUser = false
      vm.user = null
      if (auth.currentUser) {
        db.ref('Users/' + auth.currentUser.uid + '/Connected').set(false)
      }
      auth.signOut().then(function () {
        vm.$localStorage.remove('user')
        vm.goto('Login')
      }).catch(function (error) {
        // An error happened.
        console.log(error)
      })
    },
    showNewBox () {
      // this.isNewItem = true
      // this.showSuccess()
      const rountName = this.$route.name
      let eventName = ''
      switch (rountName) {
        case 'Dashboard': eventName = 'dashboardModal-open'; break
        case 'Printers': eventName = 'printerModal-open'; break
        case 'Dealers': eventName = 'dealerModal-open'; break
        case 'Customers': eventName = 'customerModal-open'; break
        case 'Sites': eventName = 'siteModal-open'; break
        case 'Users': eventName = 'userModal-open'; break
        case 'Counter': eventName = 'userModal-open'; break
        case 'Alerts': eventName = 'rulesModal-open'; break
        default: break
      }
      this.$bus.$emit(eventName)
    },
    showSuccess () {
      const vm = this
      vm.$bus.$emit('modal-new-open', {
        title: 'Register',
        description: 'Your account was succesfully created, Now you can login to your account.',
        type: 'modal-primary',
        confirmText: 'Login',
        cancelText: 'Close',
        confirmBefore: () => {
          // window.alert('confirmBefore')
        },
        confirmAfter: () => {
          // vm.$root.goto('Login')
        },
        cancelBefore: () => {
          // window.alert('cancelBefore')
        },
        cancelAfter: () => {
          // window.alert('cancelAfter')
        }
      })
    },
    showAlert (title, message) {
      const vm = this
      vm.$bus.$emit('modal-open', {
        title: title,
        description: message,
        type: 'modal-primary',
        cancelText: 'Close',
        confirmBefore: () => { },
        confirmAfter: () => { },
        cancelBefore: () => { },
        cancelAfter: () => { }
      })
    },
    reloadSlideItems () {
      if (this.isAdmin) {
        this.loadAdminSlideItems()
      } else if (this.isDealer || this.isDealerAssistance) {
        this.loadSlideItems()
      } else if (this.isCustomer) {
        this.loadCustomerSlideItems()
      }
    },
    loadAdminSlideItems () {
      const vm = this
      vm.slideItems = []
      vm.slideTopItems = []
      vm.$root.sites = []
      vm.$root.customers = []
      vm.$root.dealers = []
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-dashboard', FullName: 'Dashboard', router: { name: 'Dashboard' }, badge: { type: 'String', data: 'new' } })
      if (vm.isAdmin || vm.isDealer) {
        // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download Installer', router: { name: 'Updates' } })
        // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download Installer', router: { name: 'Updates' } })
      }
      if (vm.isAdmin || vm.isDealer) {
        vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-file-pdf-o', FullName: 'Installation Guide.pdf', router: { name: 'Guide' } })
      }
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-print', FullName: 'All Printers', router: { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'NA' } } })
      if (vm.isAdmin) {
        vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-warning', FullName: 'Activity Log', router: { name: 'Activity' } })
      }
      let itemsPath = ''
      itemsPath = 'Dealers'
      vm.slideTopItems.push({ show: true, type: 'item', isHeader: true, FullName: 'Dealers' })

      db.ref(itemsPath).once('value').then(function (snapItems) {
        const data = snapItems.val()
        if (data) {
          // console.log(data)
          const keys = Object.keys(data)
          console.log('Found (' + keys.length + ') Dealers.')
          for (let i = 0; i < keys.length; i++) {
            let dealerKey = keys[i]
            let fullName = ''
            let icon = ''
            if (!data[dealerKey].FullName || data[dealerKey].FullName.length === 0) {
              continue
            }
            fullName = '[DEALER] ' + data[dealerKey].FullName
            fullName = data[dealerKey].FullName
            // console.log(data[dealerKey].FullName)
            icon = 'fa fa-graduation-cap'
            vm.$root.dealers.push({ title: fullName, value: dealerKey, isSelected: false })
            let node = { show: true, key: dealerKey, type: 'tree', icon: icon, FullName: fullName, badge: { data: 0 } }
            node.items = []
            if (data[dealerKey].Customers) {
              let custKeys = Object.keys(data[dealerKey].Customers)
              // console.log('custKeys >>>> ' + custKeys)
              node.badge.data = custKeys.length
              for (let j = 0; j < custKeys.length; j++) {
                let custKey = custKeys[j]
                if (custKey) {
                  if (custKey === 'TotalSites') continue
                  // console.log('custKey >>>> ' + custKey)
                  let router = { name: 'Printers', params: { customerKey: custKey, siteKey: 'All', statusFilter: 'NA' } }
                  // console.log('router >>>> ' + router)
                  let custName = data[dealerKey].Customers[custKey].Name
                  // console.log('custName >>>> ' + custName)
                  if (custKey) {
                    vm.$root.customers.push({ title: custName, value: custKey, isSelected: false, dealerKey: dealerKey })
                  }
                  let item = { type: 'tree', icon: 'fa fa-user-o', FullName: custName, key: custKey, router: router }
                  item.subItems = []
                  let sites = data[dealerKey].Customers[custKey].Sites
                  if (sites) {
                    const siteKeys = Object.keys(sites)
                    if (siteKeys.length > 0) {
                      item.badge = { data: siteKeys.length }
                    }
                    for (let s = 0; s < siteKeys.length; s++) {
                      let printerCounterVersion = ''
                      let computerName = ''
                      let isUSB = false
                      let subRouter = { name: 'Printers', params: { customerKey: custKey, siteKey: siteKeys[s], statusFilter: 'NA' } }
                      let siteName = sites[siteKeys[s]].Name
                      if (sites[siteKeys[s]].ClientInfo) {
                        if (sites[siteKeys[s]].ClientInfo.PrinterCounterVersion) {
                          printerCounterVersion = sites[siteKeys[s]].ClientInfo.PrinterCounterVersion.trim()
                        }
                        if (sites[siteKeys[s]].ClientInfo.ComputerName) {
                          computerName = sites[siteKeys[s]].ClientInfo.ComputerName.trim()
                        }
                        if (sites[siteKeys[s]].ClientInfo.IsUSB) {
                          isUSB = true
                        }
                      }
                      let subItem = { show: true, type: 'item', icon: 'fa fa-map-marker', key: siteKeys[s], FullName: siteName, router: subRouter, dealerKey: dealerKey, version: printerCounterVersion, computer: computerName, isUSB: isUSB }
                      vm.$root.sites.push({ title: siteName, value: siteKeys[s], isSelected: false, customerKey: custKey, dealerKey: dealerKey })
                      item.subItems.push(subItem)
                    }
                  } else {
                    item.subItems = null
                  }
                  node.items.push(item)
                }
              }
            }
            vm.slideItems.push(node)
          }
          vm.sortSlideItems()
         // CalculateDashboard(vm, db)
        }
      })
    },
    loadSlideItems () {
      const vm = this
      vm.slideItems = []
      vm.slideTopItems = []
      vm.$root.sites = []
      vm.$root.customers = []
      vm.$root.dealers = []
      if (vm.isDealer) {
        vm.filter.dealerKey = vm.$root.user['.key']
      }
      if (vm.isDealerAssistance) {
        vm.filter.dealerKey = vm.$root.user['DealerUID']
      }
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-dashboard', FullName: 'Dashboard', router: { name: 'Dashboard' }, badge: { type: 'String', data: 'new' } })
      // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download LAN Installer', router: { name: 'DownloadLAN' } })
      // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download USB Installer', router: { name: 'DownloadUSB' } })
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-file-pdf-o', FullName: 'Installation Guide.pdf', router: { name: 'Guide' } })
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-print', FullName: 'All Printers', router: { name: 'Printers', params: { customerKey: 'All', siteKey: 'All', statusFilter: 'NA' } } })
     // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download LAN Installer', router: { name: 'DownloadLAN' } })
      // vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-download', FullName: 'Download USB Installer', router: { name: 'DownloadUSB' } })
      let itemsPath = ''
      let dealerKey = vm.filter.dealerKey
      // itemsPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers'
      itemsPath = 'Dealers/' + dealerKey + '/Customers'
      vm.slideTopItems.push({ show: true, type: 'item', isHeader: true, FullName: 'Customers' })
      let dealerName = vm.$root.user.FirstName + ' ' + vm.$root.user.LastName
      vm.$root.dealers.push({ title: dealerName, value: vm.$root.user['.key'], isSelected: true })

      db.ref(itemsPath).once('value').then(function (snapItems) {
        const data = snapItems.val()
        if (data) {
          const keys = Object.keys(data)
          for (let i = 0; i < keys.length; i++) {
            let custkey = keys[i]
            if (custkey === 'TotalSites') continue
            let fullName = ''
            let icon = ''
            fullName = data[custkey].Name
            icon = 'fa fa-user-o'
            let router = { name: 'Printers', params: { customerKey: custkey, siteKey: 'All', statusFilter: 'NA' } }
            vm.$root.customers.push({ title: fullName, value: custkey, isSelected: false, dealerKey: vm.$root.user['.key'] })
            let node = { show: true, key: custkey, type: 'tree', icon: icon, FullName: fullName, router: router, badge: { data: 0 } }
            node.items = []

            let sites = data[custkey].Sites
            if (sites) {
              const siteKeys = Object.keys(sites)
              node.badge.data = siteKeys.length
              for (let j = 0; j < siteKeys.length; j++) {
                let siteKey = siteKeys[j]
                icon = 'fa fa-map-marker'
                let router = { name: 'Printers', params: { customerKey: custkey, siteKey: siteKey, statusFilter: 'NA' } }
                let totalPrinters = sites[siteKey].TotalPrinters
                let printerCounterVersion = ''
                let computerName = ''
                let isUSB = false
                if (sites[siteKey].ClientInfo) {
                  if (sites[siteKey].ClientInfo.PrinterCounterVersion) {
                    printerCounterVersion = sites[siteKey].ClientInfo.PrinterCounterVersion.trim()
                  }
                  if (sites[siteKey].ClientInfo.ComputerName) {
                    computerName = sites[siteKey].ClientInfo.ComputerName.trim()
                  }
                  if (sites[siteKey].ClientInfo.IsUSB) {
                    isUSB = true
                  }
                }
                let item = { show: true, key: siteKey, type: 'item', icon: icon, version: printerCounterVersion, computer: computerName, isUSB: isUSB, FullName: sites[siteKey].Name, router: router, badge: { data: totalPrinters } }
                vm.$root.sites.push({ title: sites[siteKey].Name, value: siteKey, isSelected: false, customerKey: custkey, dealerKey: vm.$root.user['.key'] })
                node.items.push(item)
              }
            }
            vm.slideItems.push(node)
          }
          vm.sortSlideItems()
          // CalculateDashboard(vm, db)
        }
      })
    },
    loadCustomerSlideItems () {
      const vm = this
      vm.slideItems = []
      vm.slideTopItems = []
      vm.$root.sites = []
      vm.$root.customers = []
      vm.$root.dealers = []
      let itemsPath = ''
      let dealerKey = vm.$root.user.DealerUID
      let customerKey = vm.$root.user.CustomerKey
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-dashboard', FullName: 'Dashboard', router: { name: 'Dashboard' }, badge: { type: 'String', data: 'new' } })
      vm.slideTopItems.push({ show: true, isLink: true, type: 'item', icon: 'fa fa-print', FullName: 'All Printers', router: { name: 'Printers', params: { customerKey: customerKey, siteKey: 'All', statusFilter: 'NA' } } })
      let customer = {
        title: vm.$root.user.FirstName + ' ' + vm.$root.user.LastName,
        value: customerKey,
        isSelected: false,
        dealerKey: dealerKey
      }
      vm.$root.customers.push(customer)

      itemsPath = 'Dealers/' + dealerKey + '/Customers/' + customerKey + '/Sites'
      let dealerRef = db.ref('Dealers/' + dealerKey + '/FullName')
      db.ref(dealerRef).once('value').then(function (snapDealer) {
        const dealerName = snapDealer.val()
        console.log('Dealer FullName : ' + dealerName)
        vm.$root.dealers.push({ title: dealerName, value: dealerKey, isSelected: true })
      })

      db.ref(itemsPath).once('value').then(function (snapItems) {
        console.log(snapItems)
        const data = snapItems.val()
        if (data) {
          const keys = Object.keys(data)
          for (let i = 0; i < keys.length; i++) {
            const siteKey = keys[i]
            if (siteKey === 'TotalPrinters') {
              continue
            }
            let fullName = data[siteKey].Name
            let icon = 'fa fa-map-marker'
            let router = { name: 'Printers', params: { customerKey: customerKey, siteKey: siteKey, statusFilter: 'NA' } }
            let printerCounterVersion = ''
            let computerName = ''
            let isUSB = false
            let totalPrinters = data[siteKey].TotalPrinters
            if (data[siteKey].ClientInfo) {
              if (data[siteKey].ClientInfo.PrinterCounterVersion) {
                printerCounterVersion = data[siteKey].ClientInfo.PrinterCounterVersion.trim()
              }
              if (data[siteKey].ClientInfo.ComputerName) {
                computerName = data[siteKey].ClientInfo.ComputerName.trim()
              }
              if (data[siteKey].ClientInfo.IsUSB) {
                isUSB = true
              }
            }
            if (data[siteKey].ClientInfo) {
              if (data[siteKey].ClientInfo.PrinterCounterVersion) {
                printerCounterVersion = data[siteKey].ClientInfo.PrinterCounterVersion.trim()
              }
              if (data[siteKey].ClientInfo.ComputerName) {
                computerName = data[siteKey].ClientInfo.ComputerName.trim()
              }
              if (data[siteKey].ClientInfo.IsUSB) {
                isUSB = true
              }
            }
            let node = { show: true, key: siteKey, type: 'item', icon: icon, version: printerCounterVersion, computer: computerName, isUSB: isUSB, FullName: fullName, router: router, badge: { data: totalPrinters } }
            vm.$root.sites.push({ title: data[siteKey].Name, value: siteKey, isSelected: false, customerKey: customerKey, dealerKey: dealerKey })
            vm.slideItems.push(node)
          }
          vm.sortSlideItems()
          // CalculateDashboard(vm, db)
        }
      })
    },
    sortSlideItems () {
      this.slideItems = this.slideItems.sort(this.compareItems)
    },
    compareItems (a, b) {
      try {
        const nameA = a.FullName.toUpperCase()
        const nameB = b.FullName.toUpperCase()
        if (nameA < nameB) return -1
        if (nameA > nameB) return 1
        return 0
      } catch (e) {
        return 0
      }
    },
    shortText (txt, max) {
      if (!max) {
        max = 20
      }
      if (txt && txt.length > max) {
        txt = txt.substring(0, max - 3) + '...'
      }
      return txt
    },
    initUserHistory () {
      let vm = this
      vm.userHistory = {
        selectedPage: 'Dashboard',
        selectedDealer: '',
        selectedCustomer: 'All',
        selectedSite: 'All',
        selectedTab: '',
        fromDate: '',
        toDate: '',
        pageSize: 10
      }
    },
    setUserHistory () {
      console.log('setUserHistory()')
      let vm = this
      // alert(vm.userHistory.selectedDealer)
      /*
      if (vm.userHistory.selectedPage === 'Login' || vm.userHistory.selectedPage === 'Register') {
        return
      }
      */
      /*
      if (vm.userHistory.selectedPage === 'Settings' || vm.userHistory.selectedPage === 'Updates' || vm.userHistory.selectedPage === 'Account') {
        vm.userHistory.selectedPage = 'Dashboard'
      }
      */
      vm.$localStorage.set('userHistory', JSON.stringify(vm.userHistory))
    },
    getUserHistory () {
      let vm = this
      try {
        let userHistoryJson = vm.$localStorage.get('userHistory')
        if (userHistoryJson) {
          let userHistoryObj = JSON.parse(userHistoryJson)
          if (userHistoryObj) {
            vm.userHistory = userHistoryObj
          } else {
            vm.initUserHistory()
          }
        } else {
          vm.initUserHistory()
        }
      } catch (e) {
        console.log(e)
      }
    },
    getGUID () {
      return short().generate()
    },
    setAlert (title, message) {
      console.log('setAlert()')
      let vm = this
      let dealerKey = ''
      try {
        if (vm.$root.isDealerAssistance || vm.$root.isCustomer) {
          dealerKey = vm.$root.user.DealerUID
        } else {
          dealerKey = vm.$root.user['.key']
        }
        console.log('dealerKey = ' + dealerKey)
        db.ref('Alerts').push({
          Title: title,
          Type: 'System',
          Message: message,
          Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
          LoggedInt: vm.$moment().format('YYYYMMDDHHmmss'),
          DealerKey: dealerKey,
          CustomerKey: 'All',
          DealerCustomerKey: dealerKey + '_All',
          DateDealerKey: dealerKey + '_' + vm.$moment().format('YYYYMMDDHHmmss'),
          DateDealerCustomerKey: dealerKey + '_All_' + vm.$moment().format('YYYYMMDDHHmmss')
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js